import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const toggleStyle = (color: string, bgColor: string = color, noOpacity = false) => ({
  color: `${color} !important`,
  backgroundColor: `${noOpacity ? bgColor : bgColor + '1F'} !important`,
});

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: '16px',
    },
    categoryTitle: {
      maxWidth: '100%',
      marginRight: '30px',
      paddingLeft: '3px',
    },
    locationDetails: {
      minWidth: '300px',
      paddingTop: '10px',
      marginBottom: '10px',
    },
    buttonGroupContainer: {
      marginTop: '8px',
    },
    commentsContainer: {
      padding: '15px 15px 10px 5px',
    },
    createdDate: {
      padding: '10px 0 0 35px',
    },
    dropdown: {
      width: '30%',
    },
    locationDetailsHeader: {
      display: 'flex',
      alignItems: 'center',
    },
    dot: {
      padding: '0px 12px',
      color: MaterialPalette.primary.main,
      fontSize: '28px',
    },
    secondaryText: {
      color: MaterialPalette.text.disabled,
    },
    greenButton: toggleStyle(MaterialPalette.primary.main),
    yellowButton: toggleStyle(MaterialPalette.warning.main),
    orangeButton: toggleStyle('#F07B2A'),
    redButton: toggleStyle(MaterialPalette.error.main),
    whiteButton: toggleStyle(MaterialPalette.grey[50], MaterialPalette.grey[700], true),
  }),
);

export default useStyles;
